import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Женская футболка из хлопкового полотна с добавлением эластана – легкого и прочного материала (плотность от 155 гр/м2 до 200 гр/м2). Такая ткань имеет свойство растягиваться и восстанавливать форму, благодаря чему она практически не мнется. Футболка-стрейч идеально садится по фигуре, плотно облегая ее, при этом позволяет коже дышать. Большим плюсом также является ее устойчивость к загрязнениям и способность быстро высыхать, что делает ее удобной для повседневной носки.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`stretch_tee`],
      sizeInfo: `stretch_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
